var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        [
          _vm._v(
            " Kela-erä: " + _vm._s(_vm.batch.fileName || _vm.batch.id) + " "
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "mr-2",
              attrs: { color: "primary" },
              on: { click: _vm.showTransportEvents }
            },
            [
              _c("v-icon", { attrs: { left: "" } }, [
                _vm._v("mdi-format-list-bulleted")
              ]),
              _vm._v(" " + _vm._s(_vm.$t("kelaBatch.showEvents")) + " ")
            ],
            1
          ),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          )
        ],
        1
      ),
      _c(
        "v-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c("h3", { staticClass: "mb-3" }, [
                    _vm._v(_vm._s(_vm.$t("kelaBatch.basicInfo")))
                  ]),
                  _c("v-simple-table", { attrs: { dense: "" } }, [
                    _c("tbody", [
                      _c("tr", [
                        _c("td", [_c("strong", [_vm._v("ID")])]),
                        _c(
                          "td",
                          [
                            _vm._v(" " + _vm._s(_vm.batch.id) + " "),
                            _c(
                              "v-btn",
                              {
                                staticClass: "ml-1",
                                attrs: {
                                  icon: "",
                                  "x-small": "",
                                  title: _vm.$t("kelaBatch.copyToClipboard")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.copyToClipboard(_vm.batch.id)
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { "x-small": "" } }, [
                                  _vm._v("mdi-content-copy")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("kelaBatch.region")))
                          ])
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.batch.region))])
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("kelaBatch.year")))
                          ])
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.batch.year))])
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("kelaBatch.tilitysNro")))
                          ])
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.batch.tilitysNro))])
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("kelaBatch.siirtotunnus")))
                          ])
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.batch.siirtotunnus))])
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("kelaBatch.fileName")))
                          ])
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.batch.fileName || "-"))])
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("kelaBatch.sentAt")))
                          ])
                        ]),
                        _c("td", [
                          _vm._v(_vm._s(_vm.formatDateTime(_vm.batch.sentAt)))
                        ])
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$t("kelaBatch.containsCombinedTrips"))
                            )
                          ])
                        ]),
                        _c(
                          "td",
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  small: "",
                                  color: _vm.batch.containsCombinedTrips
                                    ? "primary"
                                    : "grey"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.batch.containsCombinedTrips
                                        ? "mdi-call-merge"
                                        : "mdi-minus"
                                    ) +
                                    " "
                                )
                              ]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.batch.containsCombinedTrips
                                    ? _vm.$t("kelaBatch.containsCombinedYes")
                                    : _vm.$t("kelaBatch.containsCombinedNo")
                                ) +
                                " "
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c("h3", { staticClass: "mb-3" }, [
                    _vm._v(_vm._s(_vm.$t("kelaBatch.summary")))
                  ]),
                  _c("v-simple-table", { attrs: { dense: "" } }, [
                    _c("tbody", [
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$t("kelaBatch.transportEventCount"))
                            )
                          ])
                        ]),
                        _c("td", [
                          _vm._v(_vm._s(_vm.batch.transportEventCount))
                        ])
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("kelaBatch.totalCost")))
                          ])
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.formatCurrency(_vm.batch.totalCost))
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$t("kelaBatch.totalReimbursement"))
                            )
                          ])
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.formatCurrency(_vm.batch.totalReimbursement)
                            )
                          )
                        ])
                      ])
                    ])
                  ]),
                  _c("h3", { staticClass: "mt-4 mb-3" }, [
                    _vm._v(_vm._s(_vm.$t("kelaBatch.feedback")))
                  ]),
                  _c("v-simple-table", { attrs: { dense: "" } }, [
                    _c("tbody", [
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("kelaBatch.feedbackStatus")))
                          ])
                        ]),
                        _c(
                          "td",
                          [
                            _c(
                              "v-chip",
                              {
                                attrs: {
                                  small: "",
                                  color: _vm.feedbackStatusColor(
                                    _vm.batch.feedbackStatus
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.feedbackStatusLabel(
                                        _vm.batch.feedbackStatus
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("kelaBatch.feedbackReceived")))
                          ])
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.batch.feedbackReceivedAt
                                ? _vm.formatDateTime(
                                    _vm.batch.feedbackReceivedAt
                                  )
                                : "-"
                            )
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("kelaBatch.feedbackFile")))
                          ])
                        ]),
                        _c("td", [
                          _vm._v(_vm._s(_vm.batch.feedbackFileName || "-"))
                        ])
                      ])
                    ])
                  ]),
                  _c("h3", { staticClass: "mt-4 mb-3" }, [
                    _vm._v(_vm._s(_vm.$t("kelaBatch.settlement")))
                  ]),
                  _c("v-simple-table", { attrs: { dense: "" } }, [
                    _c("tbody", [
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$t("kelaBatch.settlementReceived"))
                            )
                          ])
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.batch.settlementReceivedAt
                                ? _vm.formatDateTime(
                                    _vm.batch.settlementReceivedAt
                                  )
                                : "-"
                            )
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("kelaBatch.settlementFiles")))
                          ])
                        ]),
                        _c("td", [
                          _vm.batch.settlementFiles &&
                          _vm.batch.settlementFiles.length
                            ? _c(
                                "div",
                                _vm._l(_vm.batch.settlementFiles, function(f) {
                                  return _c("div", { key: f.id }, [
                                    _vm._v(" " + _vm._s(f.fileName) + " "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "grey--text text--darken-1 ml-2"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatDateTime(f.receivedAt)
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                }),
                                0
                              )
                            : _c("span", [_vm._v("-")])
                        ])
                      ])
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm.batch.transportEventIds && _vm.batch.transportEventIds.length > 0
            ? _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c(
                      "div",
                      { staticClass: "d-flex align-center mb-2" },
                      [
                        _c("h3", [
                          _vm._v(
                            _vm._s(_vm.$t("kelaBatch.eventIds")) +
                              " (" +
                              _vm._s(_vm.batch.transportEventIds.length) +
                              " kpl)"
                          )
                        ]),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ml-2",
                            attrs: {
                              icon: "",
                              small: "",
                              title: _vm.$t("kelaBatch.copyToClipboard")
                            },
                            on: { click: _vm.copyEventIds }
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("mdi-content-copy")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "event-ids-container grey lighten-4 pa-2 rounded text-caption"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.batch.transportEventIds.join(", ")) +
                            " "
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { timeout: "2000", color: "success" },
          model: {
            value: _vm.copySnackbar,
            callback: function($$v) {
              _vm.copySnackbar = $$v
            },
            expression: "copySnackbar"
          }
        },
        [_vm._v(" " + _vm._s(_vm.$t("kelaBatch.copiedToClipboard")) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }